import { render, staticRenderFns } from "./showAwait.vue?vue&type=template&id=282b40ad&scoped=true&"
import script from "./showAwait.vue?vue&type=script&lang=js&"
export * from "./showAwait.vue?vue&type=script&lang=js&"
import style0 from "./showAwait.vue?vue&type=style&index=0&id=282b40ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b40ad",
  null
  
)

export default component.exports